import {EditProps} from "react-admin";
import {DefaultEdit} from "../../components/DefaultEdit";
import {NoteConfigurationEditForm} from "./NoteConfigurationEditForm";

export const NoteConfigurationEdit = (props: EditProps) => (
  <DefaultEdit {...props}>
    <NoteConfigurationEditForm />
  </DefaultEdit>
);
